import React, { useEffect } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { TemplateQueryProps } from 'components/widgets/utility/TemplateSearch/TemplateSearchContent';
import DatasetSelectionButton from 'components/resources/datasets/DatasetSelectionButton';
import QuickSearch from 'components/widgets/utility/TemplateSearch/QuickSearch';
import { useTranslation } from 'react-i18next';
import { currentUser } from 'system/InfegyUser';
import { QueryInfo } from 'system/query/QueryInfo';
import APIRequest from 'system/APIRequest';

export interface WidgetMultiqueryPanelQueryProps {
  query: TemplateQueryProps;

  fixedDatasetId?: string;

  dashboardDatasetId?: string;

  isLoading?: boolean;
  setIsLoading?: (isLoading: boolean) => void;

  setQuery: (query: TemplateQueryProps) => void;
  onDelete: (query: TemplateQueryProps) => void;
}

export function WidgetMultiqueryPanelQuery(props: WidgetMultiqueryPanelQueryProps): JSX.Element {
  const { i18n } = useTranslation();
  const { query, fixedDatasetId, setQuery, isLoading, setIsLoading } = props;
  const user = currentUser();

  // If we don't have queryInfo yet, try to load it from the dataset
  useEffect(() => {
    const datasetId = query?.selectedDatasetId || fixedDatasetId;
    if (!datasetId || (datasetId && query?.queryInfo?.dataset?.id === datasetId)) {
      return;
    }

    APIRequest(`query/info`, {}, {
      method: 'POST',
      body: JSON.stringify({
        "dataset_id": datasetId
      }),
    }).then((response) => {
      if (!response) {
        return;
      }
      const newQueryInfo = new QueryInfo(response);
      const queryWithInfo = Object.assign(new TemplateQueryProps(user), query);
      queryWithInfo.queryInfo = newQueryInfo;
      setQuery(queryWithInfo);
    })
  }, [query.selectedDatasetId, fixedDatasetId, query.queryInfo]);


  function setDatasetId(datasetId: string | undefined) {
    if (fixedDatasetId && fixedDatasetId === datasetId) {
      return;
    }
    const queryWithDataset = Object.assign(new TemplateQueryProps(user), query);
    queryWithDataset.selectedDatasetId = datasetId;
    setQuery(queryWithDataset);
  }

  const internalDatasetId = fixedDatasetId || query.selectedDatasetId || query.queryInfo?.dataset?.id;

  return (
  <>
  {(!internalDatasetId) && (
    <Box sx={{p:2, pt: 0, pb: 1, position: "relative"}}>
      <Box sx={{ pt:0.5, pb:1, whiteSpace: "nowrap"}}>
        <Typography variant="body1" sx={{ ml: 0, pt: 1}}>
          {i18n.t('query-form.create-query')}
        </Typography>
      </Box>
      <Box sx={{}}>
        {props.dashboardDatasetId && (
        <>
          <Button
            variant="outlined"
            onClick={() => {
              setDatasetId(props.dashboardDatasetId);
            }}
          >
            {i18n.t('Use Dashboard Dataset')}
          </Button>
          <Typography variant="body1" sx={{ display: "inline-block", ml: 1, mr: 1 }}>
            {i18n.t('or')}
          </Typography>
        </>
        )}
        <DatasetSelectionButton
          selectedDatasetId={""}
          setSelectedDatasetId={(datasetId:string | undefined) => {
            if (datasetId) {
              setDatasetId(datasetId);
            }
          }}
        />
      </Box>
    </Box>
  )}
  {(internalDatasetId) && (
    <QuickSearch
      queryInfo={query.queryInfo}
      datasetId={internalDatasetId}
      canDelete={true}
      templateQuery={query}
      isLoading={isLoading}
      setIsLoading={setIsLoading}
      setTemplateQuery={(templateQuery:TemplateQueryProps) => {
        setQuery(templateQuery);
      }}
      onDelete={() => {
        props.onDelete(query);
      }} />
    )}
    </>
  );
}
